export default {
  open(callback) {
    let request=window.indexedDB.open("dev-local-history");
    request.onsuccess=function (event) {
      let db = event.target.result;
      let tx = db.transaction('defaultStore','readwrite');
      let store = tx.objectStore('defaultStore');
      callback(db,store);
    };
    request.onupgradeneeded = function(event) {
      let db = event.target.result;
      let store=db.createObjectStore('defaultStore',{ autoIncrement: true });
      store.createIndex('key', 'key', { unique: false });
    };
  },
  add(key, data,callback) {
    let me=this;
    this.open(function(db,store){
      let req=store.add({data:data,time:new Date().getTime(),key:key});
      req.onsuccess=function(){
        if(callback)callback();
        db.close();
        setTimeout(()=>{
          me.clear();
        },10);
      }
    })
  },
  get(key,callback){
    this.open(function(db,store){
      //let req=store.get(key);
      let keyIndex = store.index("key");
      let req
      if(key){
        req= keyIndex.openCursor(IDBKeyRange.only(key));
      }else{
        req= keyIndex.openCursor();
      }
      let records=[];
      req.onsuccess=function(event){
        let cursor = event.target.result;
        if (cursor) {
          let d=Object.assign({},cursor.value);
          d.primaryKey=cursor.primaryKey;
          records.push(d);
          cursor.continue();
        } else {
          callback(records);
        }
      }
    });
  },
  clear() {
    this.get(null,records=>{
      //每个key分类下只保留20条，其他的删除掉。
      let deleteKeys=_(records).groupBy("key")
        .mapValues(v=>_.sortBy(v,"time").reverse().slice(19).map(o=>o.primaryKey))
        .values().flatten().value();
      this.open((db,store)=>{
        deleteKeys.forEach(k=>store.delete(k));
      });
    });
  }
}




// WEBPACK FOOTER //
// ./src/modules/index/components/code-edit/localHistoryDB.js